(function ($) {
    function hydrateReventHeroBanners() {
        var scriptEl = document.querySelector('script[src*="halo.slide-show.js"]');
        var basePath = scriptEl ? scriptEl.src.split('halo.slide-show.js')[0] : '//uae.revent.store/cdn/shop/t/23/assets/';
        var heroAssets = {
            1: {
                pc: basePath + 'revent-uae-home-hero-laptops-desktop-professional.webp',
                mb: basePath + 'revent-uae-home-hero-laptops-mobile-professional.webp',
                link: '/collections/laptops'
            },
            2: {
                pc: basePath + 'revent-uae-home-hero-phones-desktop-professional.webp',
                mb: basePath + 'revent-uae-home-hero-phones-mobile-professional.webp',
                link: '/collections/apple-iphones'
            },
            3: {
                pc: basePath + 'revent-uae-home-hero-truecheck-desktop-professional.webp',
                mb: basePath + 'revent-uae-home-hero-truecheck-mobile-professional.webp',
                link: '/collections/all'
            }
        };

        var slides = document.querySelectorAll('.slideshow .item[data-index]');
        if (!slides.length) {
            slides = document.querySelectorAll('.slideshow .item');
        }

        slides.forEach(function (slide, idx) {
            var slideNum = parseInt(slide.getAttribute('data-index'), 10) || (idx + 1);
            var data = heroAssets[slideNum];
            if (!data) return;

            var pcImg = slide.querySelector('.slide-pc img');
            if (pcImg && pcImg.src.indexOf('revent-uae-home-hero') === -1) {
                pcImg.src = data.pc;
                pcImg.srcset = data.pc;
                pcImg.removeAttribute('data-src');
                pcImg.removeAttribute('data-srcset');
            }

            var mbImg = slide.querySelector('.slide-mobile img');
            if (mbImg && mbImg.src.indexOf('revent-uae-home-hero') === -1) {
                mbImg.src = data.mb;
                mbImg.srcset = data.mb;
                mbImg.removeAttribute('data-src');
                mbImg.removeAttribute('data-srcset');
            }

            if (!pcImg && !mbImg) {
                var anyImgs = slide.querySelectorAll('img');
                anyImgs.forEach(function (img) {
                    if (img.src.indexOf('revent-uae-home-hero') === -1) {
                        img.src = data.pc;
                        img.srcset = data.pc;
                    }
                });
            }

            if (data.link) {
                var links = slide.querySelectorAll('a.slide-image');
                links.forEach(function (a) {
                    a.href = data.link;
                });
            }
        });
    }

    hydrateReventHeroBanners();
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', hydrateReventHeroBanners);
    }

    function init() {
        hydrateReventHeroBanners();
        var $jq = window.jQuery || window.$;
        if (typeof $jq === 'undefined' || typeof $jq.fn.slick === 'undefined') {
            setTimeout(init, 50);
            return;
        }

        var slickSlideshow = $jq('[data-init-slideshow]');
        if (!slickSlideshow.length) return;

        slickSlideshow.each(function () {
            var self = $jq(this);
            if (self.hasClass('slick-initialized')) return;

            var auto_playvideo = self.data('auto-video');

            if (self.find('.item-video').length && !window.YT) {
                var tag = document.createElement('script');
                tag.src = "https://www.youtube.com/iframe_api";
                var firstScriptTag = document.getElementsByTagName('script')[0];
                if (firstScriptTag && firstScriptTag.parentNode) {
                    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
                }
            }

            if (auto_playvideo) {
                function postMessageToPlayer(player, command) {
                    if (player == null || command == null) return;
                    player.contentWindow.postMessage(JSON.stringify(command), "*");
                }

                function playPauseVideo(slick, control) {
                    var currentSlide = slick.find('.slick-current .item');
                    var player = currentSlide.find("iframe").get(0);

                    if (currentSlide.hasClass('slide-youtube')) {
                        var id = currentSlide.find('iframe').attr('id');
                        var video_id = currentSlide.find('iframe').data('video-id');
                        if (control === "play") {
                            postMessageToPlayer(player, { "event": "command", "func": "playVideo" });
                            self.slick('slickPause');
                            $jq(player).on('ended', function () {
                                postMessageToPlayer(player, { "event": "command", "func": "playVideo" });
                                self.slick('slickPlay');
                                self.slick('next');
                            });
                        } else {
                            postMessageToPlayer(player, { "event": "command", "func": "pauseVideo" });
                        }

                        if (window.YT && window.YT.Player) {
                            new YT.Player(id, {
                                videoId: video_id,
                                events: {
                                    'onReady': function (e) { e.target.playVideo(); },
                                    'onStateChange': function (e) {
                                        if (e.data === 0) {
                                            postMessageToPlayer(player, { "event": "command", "func": "playVideo" });
                                            self.slick('slickPlay');
                                            self.slick('next');
                                        }
                                    }
                                }
                            });
                        }
                    } else if (currentSlide.hasClass('slide-video')) {
                        var video = currentSlide.find("video").get(0);
                        if (video != null) {
                            if (control === "play") {
                                video.play();
                                self.slick('slickPause');
                                $jq(video).on('ended', function () {
                                    self.slick('slickPlay');
                                    self.slick('next');
                                });
                            } else {
                                video.pause();
                            }
                        }
                    }
                }

                self.on('init', function (e, slick) {
                    var s = $jq(slick.$slider);
                    setTimeout(function () {
                        playPauseVideo(s, "play");
                    }, 1000);
                });

                self.on("beforeChange", function (event, slick) {
                    var s = $jq(slick.$slider);
                    playPauseVideo(s, "pause");
                    self.on("mouseenter focus", function () {
                        $jq('.home-slideshow .slideshow').addClass('over_hover');
                    });
                });

                self.on("afterChange", function (event, slick) {
                    $jq('.item.slick-slide:not(.slick-current) .fluid-width-video-wrapper .video').css('display', 'none');
                    $jq('.slick-current .fluid-width-video-wrapper .video').css('display', 'block');
                    var s = $jq(slick.$slider);
                    playPauseVideo(s, "play");
                });
            }

            var dotsData = self.data('dots');
            var dots = dotsData !== 'none' && dotsData !== false && dotsData !== 'false';
            var arrowsMobile = false;
            var customPaging = function (slider, i) {
                return '<button type="button" role="tab" aria-label="' + (i + 1) + '">' + (i + 1) + '</button>';
            };

            if (dotsData === 'number') {
                arrowsMobile = true;
                customPaging = function (slider, i) {
                    var index = i + 1;
                    var count = (slider && slider.slideCount) || self.find('.item').length;
                    return '<a class="dot" aria-label="' + index + '/' + count + '">' + index + '/' + count + '</a>';
                };
            }

            var fadeVal = self.data('fade');
            var isFade = fadeVal === true || fadeVal === 'true';

            var nextArrowIcon = (window.arrows && window.arrows.icon_next) ? window.arrows.icon_next : '<button type="button" class="slick-next" aria-label="Next">Next</button>';
            var prevArrowIcon = (window.arrows && window.arrows.icon_prev) ? window.arrows.icon_prev : '<button type="button" class="slick-prev" aria-label="Previous">Previous</button>';

            self.on('init reInit setPosition', function () {
                self.removeClass('slick-loading');
                self.find('.slick-track').css({ 'opacity': '1', 'visibility': 'visible' });
                self.find('.slick-list').css({ 'height': 'auto', 'opacity': '1', 'visibility': 'visible' });
                self.find('.slick-slide').css({ 'opacity': '1', 'visibility': 'visible' });
                self.find('.slick-slide img, .slick-cloned img').css({ 'opacity': '1', 'visibility': 'visible', 'display': 'block' });
            });

            try {
                self.slick({
                    dots: dots,
                    slidesToScroll: 1,
                    verticalSwiping: false,
                    fade: isFade,
                    cssEase: "ease",
                    adaptiveHeight: false,
                    autoplay: self.data('autoplay'),
                    autoplaySpeed: self.data('autoplay-speed') || 5000,
                    arrows: self.data('arrows') !== false && self.data('arrows') !== 'false',
                    nextArrow: nextArrowIcon,
                    prevArrow: prevArrowIcon,
                    customPaging: customPaging,
                    rtl: window.rtl_slick || false,
                    speed: self.data('speed') || 500,
                    responsive: [
                        {
                            breakpoint: 1280,
                            settings: {
                                arrows: arrowsMobile,
                                customPaging: customPaging,
                                dots: dots
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                arrows: arrowsMobile,
                                customPaging: customPaging,
                                dots: dots
                            }
                        }
                    ]
                });
            } catch (err) {
                console.error('Error initializing slideshow:', err);
                self.find('.slick-track, .slick-list, .slick-slide, img').css({ 'opacity': '1', 'visibility': 'visible', 'display': 'block' });
            }
        });
    }

    if (typeof jQuery !== 'undefined') {
        jQuery(document).ready(init);
    }
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
        setTimeout(init, 0);
    } else {
        document.addEventListener('DOMContentLoaded', init);
    }
    document.addEventListener('shopify:section:load', init);
    window.addEventListener('load', init);
})(window.jQuery || window.$);

